var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9 2H15M3 5H21M19 5L18.2987 15.5193C18.1935 17.0975 18.1409 17.8867 17.8 18.485C17.4999 19.0118 17.0472 19.4353 16.5017 19.6997C15.882 20 15.0911 20 13.5093 20H10.4907C8.90891 20 8.11803 20 7.49834 19.6997C6.95276 19.4353 6.50009 19.0118 6.19998 18.485C5.85911 17.8867 5.8065 17.0975 5.70129 15.5193L5 5M10 9.5V14.5M14 9.5V14.5",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash03);
export default __webpack_public_path__ + "static/media/trash-03.4dabbc1d0e0b9d87484a793bf28501a8.svg";
export { ForwardRef as ReactComponent };